export default "__VITE_ASSET__V84vdJpr__"